/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Section/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import ImageTitle from './ImageTitle/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Section({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Sections/Section",
  marginLeft,
  marginRight
  
}) {
let imagesComparisonSectionsOrientationValueData = fromData.useDataValue({ viewPath,
context: 'images_comparison_sections',
path: 'orientation',
})
let constantData = 'vertical'
let aggregateData = fromAggregate.equals(imagesComparisonSectionsOrientationValueData, constantData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Section.Vertical"
  data-view-path={viewPath}
 style={{'--ml-3-ZLF3dX': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-4-ZLF3dX': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-5-ZLF3dX': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-1-ZLF3dX': aggregateData ? "48%" : "100%",'--w-2-ZLF3dX': aggregateData ? "100%" : "50%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Section.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
<ImageTitle
  viewPath={`${viewPath}/ImageTitle`}
/>
</div>
{children}
</React.Fragment>)
}